<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="{ path: 'message.title_edit_layer_client_setting', args: { name: nodeInfo.name } }"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="150px" >
                        <div class="dialog-form-item">
                            <el-form-item prep="clientSettingName" ref="clientSettingName" label-width="200px">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_client_setting_name'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-select class="select-option-item" v-model="newClientSettingId" @change="setButtonStatus()">
                                    <el-option v-for="clientSetting in clientSettingList" :key="clientSetting.settingId" :label="clientSetting.settingName" :value="clientSetting.settingId"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableButton" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    props: ['nodeInfo', 'clientSettingId', 'clientSettingList' ],
    data() {
        return {
            disableButton: true,
            clientSettingName: null,
            newClientSettingId: 0,
            clientSettingList: []
        };
    },
    created: function() {
        this.newClientSettingId = this.clientSettingId;
    },
    methods: {
        saveChange: function() {
            this.$emit('save', {newClientSettingId: this.$data.newClientSettingId });
        },
        setButtonStatus: function() {
            if (this.clientSettingId !== this.newClientSettingId) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
    }
}
</script scoped>

